"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUid = void 0;
function dec2hex(dec) {
    return ("0" + dec.toString(16)).substr(-2);
}
function generateUid(len) {
    // tslint:disable-next-line: no-string-literal
    const crypto = window.crypto || window["msCrypto"];
    const arr = new Uint8Array((len || 40) / 2);
    crypto.getRandomValues(arr);
    return `${Date.now()
        .toString()
        .substring(7)}:${Array.from(arr, dec2hex).join("")}`;
}
exports.generateUid = generateUid;
//# sourceMappingURL=generateUid.js.map